const MealCardPlaceholder = ({ className = '' }) => (
  <svg viewBox="0 0 368 420" className={className} role="presentation" aria-hidden={true}>
    <path
      d="M16,290a12,12,0,0,1,12-12H277.53a12,12,0,0,1,0,24H28A12,12,0,0,1,16,290ZM368,12V408a12,12,0,0,1-12,12H12A12,12,0,0,1,0,408V12A12,12,0,0,1,12,0H356a11.94,11.94,0,0,1,7.63,2.74,11.42,11.42,0,0,1,1.63,1.63A11.94,11.94,0,0,1,368,12Zm-2,248H2V408a10,10,0,0,0,10,10H356a10,10,0,0,0,10-10ZM28,342H188a12,12,0,0,0,0-24H28a12,12,0,0,0,0,24Zm0,58H96a12,12,0,0,0,0-24H28a12,12,0,0,0,0,24Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

MealCardPlaceholder.propTypes = {
  className: PropTypes.string,
};

export default MealCardPlaceholder;
